/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_LiftedInputs */



/**
* | output |
* | --- |
* | "Lifted" |
*
* @param {Sanction_LiftedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_lifted = /** @type {((inputs?: Sanction_LiftedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_LiftedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Levée")
	if (locale === "es") return /** @type {LocalizedString} */ ("Levantada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Removida")
	if (locale === "it") return /** @type {LocalizedString} */ ("Revocata")
	return /** @type {LocalizedString} */ ("Lifted")
});